export default __webpack_public_path__ + "static/media/tw-reporter-og.e6720706.jpg";